import React, { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { commonApi } from "../../constants/apis/adminCommunication";
import { toast } from "react-toastify";
import Spinner from "../../commanComponents/Spinner";
import { userRole } from "../../constants/Helper/getUserRole";

ChartJS.register(ArcElement, Tooltip, Legend);

const DoughnutChart = () => {
  const [loading, setLoading] = useState(false);
  const [complaintData, setComplaintData] = useState({
    totalComplaints: 0,
    pendingComplaints: 0,
    resolvedComplaints: 0,
  });
  const isEmptyData =
    complaintData?.totalComplaints === 0 &&
    complaintData?.resolvedComplaints === 0 &&
    complaintData?.pendingComplaints === 0;

  const fetchGrivanceData = async () => {
    try {
      setLoading(true);
      const serverUrl =
        (await userRole()) === "zonal"
          ? commonApi.getGrivanceDataforZonal()
          : commonApi.getGrivanceData();
      const serverResponse = await serverUrl;
      if (
        serverResponse?.status === "SUCCESS" &&
        serverResponse?.complaintData?.totalComplaints > 0
      ) {
        setComplaintData(serverResponse?.complaintData);
      } else if (
        serverResponse?.status === "SUCCESS" &&
        serverResponse?.complaintData?.totalComplaints === 0
      ) {
        setComplaintData({
          totalComplaints: 0,
          pendingComplaints: 0,
          resolvedComplaints: 0,
        });
      } else if (serverResponse?.status === "JWT_INVALID") {
        toast.info(`Failed : ${serverResponse?.message}`);
      } else if (serverResponse?.status === "FAILED") {
        toast.error(`Failed : ${serverResponse?.message}`);
      }
    } catch (error) {
      toast.error(`Failed : ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGrivanceData();
  }, []);

  const data = {
    labels: ["Resolved", "Pending"],
    datasets: [
      {
        label: "Grievance Complaints",
        data: [
          complaintData?.resolvedComplaints,
          complaintData?.pendingComplaints,
        ],
        backgroundColor: ["#4CAF50", "#FFA726"],
        hoverBackgroundColor: ["#45a049", "#FF9800"],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    cutout: "62%",
    plugins: {
      tooltip: {
        enabled: true,
      },
      legend: {
        display: false,
      },
    },
  };

  useEffect(() => {
    console.log("-----------------", complaintData);
  }, [complaintData]);

  return (
    <div className="DoughnutChartWrapper big_Shadow mt-1 container-fluid">
      <h5 className="text-center mb-4 fw-bold">Grievance Complaints</h5>

      {isEmptyData && !loading ? (
        <div className="text-center py-5">
          <h6 className="fw-semibold text-muted">
            No grievance complaints available
          </h6>
          <p className="text-secondary">
            Sit back and relax—everything’s quiet for now!
          </p>
        </div>
      ) : (
        <div className="row justify-content-center align-items-center">
          <div className="col-md-4 col-sm-12 mb-3">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                justifyContent: "space-between",
                fontSize: "15px",
                fontWeight: "500",
              }}
            >
              <div
                style={{
                  backgroundColor: "#2196F3",
                  color: "white",
                  padding: "5px 10px",
                  borderRadius: "5px",
                }}
              >
                {complaintData?.totalComplaints} Total
              </div>
              <div
                style={{
                  backgroundColor: "#4CAF50",
                  color: "white",
                  padding: "5px 10px",
                  borderRadius: "5px",
                }}
              >
                {complaintData?.resolvedComplaints} Resolved
              </div>
              <div
                style={{
                  backgroundColor: "#FFA726",
                  color: "white",
                  padding: "5px 10px",
                  borderRadius: "5px",
                }}
              >
                {complaintData?.pendingComplaints} In Progress
              </div>
            </div>
          </div>

          <div className="col-md-6 col-sm-12">
            <div
              style={{ position: "relative", maxWidth: "100%", margin: "auto" }}
            >
              <div style={{ marginTop: "20px" }}>
                <Doughnut data={data} options={options} />
              </div>
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  textAlign: "center",
                  fontSize: "22px",
                  fontWeight: "bold",
                  color: "#4CAF50",
                }}
              >
                <div>{loading ? <Spinner /> : "Grievance"}</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DoughnutChart;
